import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FilterCountService {

  constructor() { }

  contarFiltros(filtros) {
    let nuevaCantidad = 0;
    Object.keys(filtros).forEach(f => {
      const filtro = filtros[f];
      if (filtro) {
        if (filtro.hasOwnProperty('dropdown') && filtro.hasOwnProperty('valor')) {
          nuevaCantidad += this.contarCandidadFiltros(filtro.valor);
        } else {
          nuevaCantidad += this.contarCandidadFiltros(filtro);
        }
      }
    });
    return nuevaCantidad;
  }

  private contarCandidadFiltros(valor) {
    if (valor == null || typeof valor === 'undefined' || valor === '') {
      return 0;
    }
    if (valor instanceof Array) {
      return valor.length;
    }
    if (valor instanceof Object && valor.hasOwnProperty('desde')) {
      let count = 0;
      if (valor.desde) count +=1;
      if (valor.hasta) count +=1;
      return count;
    }
    return 1;
  }
}
